/* global moment */
angular
  .module('statInsurance')
  .component('statInsurance', {
    template: require('./stat-insurance.template.html'),
    controller: ['$rootScope', '$scope', '$resource', '$route', '$location', '$window', '$translate', 'AuthService', 'envService',
      function StatEmployeeController($rootScope, $scope, $resource, $route, $location, $window, $translate, AuthService, envService) {
        $scope.showEmployeeView = $rootScope.gShowEmployeeView;
        $scope.showUserView = $rootScope.gShowUserView;
        $scope.doLogout = $rootScope.gLogout;
        $rootScope.mainmenu = 'stat';
        $rootScope.menu = 'insurance';
        $scope.selectedCityId = '-1';
        const APIURL = envService.read('apiUrl');
        if (!AuthService.isAuthenticated()) {
          $location.path('/login');
          return;
        }

        this.from_date = moment().startOf('month').format('YYYY-MM-DD');
        this.to_date = moment().endOf('month').format('YYYY-MM-DD');

        $scope.reload = () => {
          $resource(`${APIURL}/admin/stat/th/insurance/daily`)
            .get({ from: this.from_date, to: this.to_date }).$promise
            .then((data) => {
              this.stats = data.stats;
            });
        };

        $scope.onDatePick = () => {
          this.from_date = jQuery('#inputPickerFrom').val();
          this.to_date = jQuery('#inputPickerTo').val();
          $scope.reload();
        };

        this.showUsers = (date, type) => {
          this.dayPayload = { date, type, page: 0 };
          $resource(`${APIURL}/admin/stat/th/insurance/users`)
            .get(this.dayPayload).$promise
            .then((data) => {
              console.log(data);
              this.dayData = data;
              jQuery('#modal-view-day').modal('show');
            });
        };

        this.pagingUsers = (page) => {
          this.dayPayload.page = page - 1;
          $resource(`${APIURL}/admin/stat/th/insurance/users`)
            .get(this.dayPayload).$promise
            .then((data) => {
              console.log(data);
              this.dayData = data;
            });
        };

        $scope.reload();
      },
    ],
  });



// WEBPACK FOOTER //
// ./src/app/stat-insurance/stat-insurance.component.js